"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchRoute = void 0;
var react_router_dom_1 = require("react-router-dom");
/**
 * Using React Router's `matchPath` function, chooses the
 * controller that matches the inbound request path.
 *
 * @param controllers An array of application controllers.
 * @param path The incoming request path, e.g. `/Hotels`.
 */
var matchRoute = function (controllers, path, options) {
    if (options === void 0) { options = {}; }
    var match;
    var result = {};
    var hasPrefix = options.baseUrl && path.indexOf(options.baseUrl) === 0;
    var strippedPath = hasPrefix ? path.replace(new RegExp('^' + options.baseUrl), '') : path;
    controllers.some(function (controller) {
        match = (0, react_router_dom_1.matchPath)(strippedPath, controller);
        if (match) {
            result = {
                route: controller,
                params: match.params,
                location: {
                    path: path,
                    pathname: controller.routeName || 'unknown'
                }
            };
            return true;
        }
        return false;
    });
    return result;
};
exports.matchRoute = matchRoute;
//# sourceMappingURL=match-route.js.map